export default __webpack_public_path__ + "static/media/061-saba-island.9d101465.svg";